import { bridgeErrorKind } from '@heidi/plugin-core';
import { rpaBridge } from '@heidi/plugin-rpa';
import { logger, sanitizeError } from '@heidi/runtime/logger';
import { agentHarnessClient } from '../../agent-harness/client';

/**
 * Cancel the turn server-side and stop its local executor. Port-free, so the
 * logout path can run it before the app wires its ports. `onCancelled` runs
 * after a successful cancel.
 */
export const cancelComputerUseRunSettled = async (
  agentRunId: string,
  onCancelled?: () => void
): Promise<void> => {
  const cancel = agentHarnessClient
    .cancelTurn(agentRunId)
    .then(() => {
      onCancelled?.();
    })
    .catch((error: unknown) => {
      logger.warn('[rpa] cancel computer-use run failed', {
        agent_run_id: agentRunId,
        errorKind: bridgeErrorKind(error),
        error: sanitizeError(error),
      });
    });
  const stop = rpaBridge.isAvailable()
    ? rpaBridge.stopRunExecutorFor(agentRunId).catch((error: unknown) => {
        // Latency bonus only — BE cancel is source of truth — but ACL rejects
        // (missing allow-stop-run-executor-for) must not stay silent.
        logger.warn('[rpa] stop run executor for cancel failed', {
          agent_run_id: agentRunId,
          errorKind: bridgeErrorKind(error),
          error: sanitizeError(error),
        });
      })
    : undefined;
  await Promise.all([cancel, stop]);
};
